import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'mb-section-headline',
  templateUrl: './section-headline.component.html',
  styleUrls: ['./section-headline.component.scss'],
})
export class SectionHeadlineComponent {
  @HostBinding('class.has-headline')
  @Input()
  headline = '';
  @Input() anchor = '';
  @Input() theme: string = 'inherit'; // 'dark' | 'light' | 'inherit'
  @Input() containerClass: string = 'container-sm';
}
